<template>
  <div class="product-container pt-5 position-relative vw-100">
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterModal"
        v-on:enter="actions.enterModal"
        v-on:leave="actions.leaveModal"
    >
		<div class="product-instructions">
			<LocalizedLink to="/"  class="close-detail position-absolute"></LocalizedLink>

			<arrow arrow-class="arrow-left" target="/elevator"></arrow>
			<arrow arrow-class="arrow-right" target="/living-room"></arrow>

			<div class="product-copy-container">
				<transition name="bounce">
					<div v-if="show">
						<div class="product-title">
							<div class="product-name" v-html="$t('dorm_room_screen.title')"></div>
						</div>
						<div class="product-inst" v-html="$t('dorm_room_screen.content')"></div>
					</div>
				</transition>
			</div>

		</div>
    </transition>
		<div class="product-detail position-absolute">
      <div class="detail-inner" :style="{'background-image': 'url(' + require('@/assets/imgs/product-one/product.jpg') + ')'}">
      </div>
		</div>
  </div>
</template>

<script>
import Arrow from "../Arrow";
import LocalizedLink from '@/components/LocalizedLink'
import {inject} from "vue";

export default {
  name: "DormRoomPage",
  components: {
		Arrow,
		LocalizedLink
	},
	setup() {
    const store = inject("store");
    return {
      actions: store.actions
    };
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 800);
  }
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 728px) {
  .detail-view {
    .product-detail {
      // bottom: 0;
      .detail-inner {
          background-position: 90% 50%;
              background-size: auto 100%;
        // position: absolute;
        // float: right; /* this was added and display removed */
        // right: 0;
        // bottom: 0;
      }
    }
  }


}
@media screen and (min-width: 729px) {
  .detail-view {
    .product-detail {
      // top: auto;
      // bottom: 0;
    }
  }
}
</style>
